function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.605,
    height: 8.545,
    viewBox: "0 0 16.605 8.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16356",
    d: "M19.009 14.977a1.813 1.813 0 0 0-2.286 0L11.2 19.723l-5.525-4.746a1.794 1.794 0 0 0-1.582-.4 1.521 1.521 0 0 0-1.165 1 1.269 1.269 0 0 0 .462 1.36l6.666 5.733a1.813 1.813 0 0 0 2.286 0l6.668-5.731a1.259 1.259 0 0 0 0-1.968z",
    transform: "translate(-2.876 -14.536)",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.6ee0bb3c813dbcc8d61c9cd5ff7e4155.svg";
export { ForwardRef as ReactComponent };